import getSymbolFromCurrency from 'currency-symbol-map';

export const toCurrencyAmount = (amount: number, currency: string) => {
  const amountDecimal = amount;
  const symb = getSymbolFromCurrency(currency);

  return `${symb}${amountDecimal}`;
};
